/**
 * @file コンポーネント：ページング スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPagination = styled.nav`
    display: flex;
    justify-content: center;
`;

export const StyledPaginationAnchor = styled.a`
    display: block;
    min-width: 18px;
    padding: 3px;
    border-width: 1px;
    border-style: solid;
    font-size: 16px;
    line-height: 16px;
    text-align: center;

    &[data-on-color="main"] {
        border-color: #acadae;
        color: #acadae;
    }

    &[data-on-color="sub"] {
        border-color: #acadae;
        color: #acadae;
    }

    &[data-on-color="white"] {
        border-color: #acadae;
        color: #acadae;
    }
`;

export const StyledPaginationCurrent = styled.span`
    display: block;
    min-width: 18px;
    padding: 3px;
    border: 1px solid transparent;
    font-weight: bold;
    font-size: 16px;
    line-height: 16px;
    text-align: center;

    &[data-on-color="main"] {
        background-color: #acadae;
        color: #343a40;
    }

    &[data-on-color="sub"] {
        background-color: #acadae;
        color: #343a40;
    }

    &[data-on-color="white"] {
        background-color: #acadae;
        color: #343a40;
    }
`;

export const StyledPaginationInactive = styled.span`
    display: block;
    min-width: 18px;
    padding: 3px;
    border: 1px solid transparent;
    font-weight: bold;
    font-size: 16px;
    line-height: 16px;
    text-align: center;

    &[data-on-color="main"] {
        color: #acadae;
    }

    &[data-on-color="sub"] {
        color: #acadae;
    }

    &[data-on-color="white"] {
        color: #acadae;
    }
`;

export const StyledPaginationList = styled.ul`
    display: inline-flex;
    justify-content: center;
`;

export const StyledPaginationListItem = styled.li`
    margin-right: 12px;

    &:last-of-type {
        margin-right: 0;
    }
`;
